export default __webpack_public_path__ + "static/barlow-v4-latin-300-7dcf11bdca64433f3fe6852db2b8d122.eot";